import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule as SharedComponentsModule } from 'src/app/shared/components/components.module';

import { RetailRoutingModule } from './retail-routing.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RetailRoutingModule,
    NgbDropdownModule,
    SharedComponentsModule,
  ],
  exports: [
    NgbDropdownModule
  ]
})
export class RetailModule { }
